import React from 'react';
import Navbar from '../components/Navbar/navbar';
import Sendcv from '../components/admin/CVSending';

function CvSend() {

  return (
    <div className='newAdmin'>   
    <Navbar/>
    <Sendcv/>
    </div>
  )
}

export default CvSend;
